// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDAG2K8KT3Ykg-ZLpGo98d6YNegzgNB-mM',
    authDomain: 'appointx-demo.firebaseapp.com',
    databaseURL: 'https://appointx-demo.firebaseio.com',
    projectId: 'appointx-demo',
    storageBucket: 'appointx-demo.appspot.com',
    messagingSenderId: '172916290463',
    appId: '1:172916290463:web:ee8d41e0d957779b8883aa',
    measurementId: 'G-GHMCLCFZ3S'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
